"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scriptBold = {
    0x20: [0, 0, .25],
    0x41: [.717, .008, .803, { ic: .213, sk: .389 }],
    0x42: [.708, .028, .908, { ic: .02, sk: .194 }],
    0x43: [.728, .026, .666, { ic: .153, sk: .278 }],
    0x44: [.708, .031, .774, { ic: .081, sk: .111 }],
    0x45: [.707, .008, .562, { ic: .156, sk: .139 }],
    0x46: [.735, .036, .895, { ic: .095, sk: .222 }],
    0x47: [.717, .037, .61, { ic: .128, sk: .25 }],
    0x48: [.717, .036, .969, { ic: .272, sk: .333 }],
    0x49: [.717, .017, .809, { ic: .137, sk: .333 }],
    0x4A: [.717, .314, 1.052, { ic: .081, sk: .417 }],
    0x4B: [.717, .037, .914, { ic: .29, sk: .361 }],
    0x4C: [.717, .017, .874, { ic: .161, sk: .306 }],
    0x4D: [.721, .05, 1.08, { ic: .136, sk: .444 }],
    0x4E: [.726, .036, .902, { ic: .306, sk: .389 }],
    0x4F: [.707, .008, .738, { ic: .067, sk: .167 }],
    0x50: [.716, .037, 1.013, { ic: .018, sk: .222 }],
    0x51: [.717, .017, .883, { sk: .278 }],
    0x52: [.717, .017, .85, { ic: .037, sk: .194 }],
    0x53: [.708, .036, .868, { ic: .148, sk: .333 }],
    0x54: [.735, .037, .747, { ic: .249, sk: .222 }],
    0x55: [.717, .017, .8, { ic: .16, sk: .25 }],
    0x56: [.717, .017, .622, { ic: .228, sk: .222 }],
    0x57: [.717, .017, .805, { ic: .221, sk: .25 }],
    0x58: [.717, .017, .944, { ic: .187, sk: .278 }],
    0x59: [.716, .017, .71, { ic: .249, sk: .194 }],
    0x5A: [.717, .016, .821, { ic: .211, sk: .306 }],
    0xA0: [0, 0, .25],
    0x391: [.698, 0, .869],
    0x392: [.686, 0, .818],
    0x395: [.68, 0, .756],
    0x396: [.686, 0, .703],
    0x397: [.686, 0, .9],
    0x399: [.686, 0, .436],
    0x39A: [.686, 0, .901],
    0x39C: [.686, 0, 1.092],
    0x39D: [.686, 0, .9],
    0x39F: [.696, .01, .864],
    0x3A1: [.686, 0, .786],
    0x3A2: [.696, .01, .894],
    0x3A4: [.675, 0, .8],
    0x3A7: [.686, 0, .869],
    0x3D2: [.697, 0, .894],
    0x3DC: [.68, 0, .724],
};
//# sourceMappingURL=script-bold.js.map